<script>
import { LabeledInput } from '@components/Form/LabeledInput';
import { RadioGroup } from '@components/Form/Radio';

export default {
  components: { LabeledInput, RadioGroup },
  props:      {
    value:      {
      type:    Object,
      default: () => ({})
    },
    mode: {
      type:     String,
      required: true,
    },
  },
  data() {
    const yesNoOptions = [
      {
        label: this.t('generic.yes'),
        value: true
      },
      {
        label: this.t('generic.no'),
        value: false
      }
    ];

    this.$set(this.value.spec, 'storageos', this.value.spec.storageos || {});
    this.$set(this.value.spec.storageos, 'readOnly', this.value.spec.storageos.readOnly || false);
    this.$set(this.value.spec.storageos, 'secretRef', this.value.spec.storageos.secretRef || {});

    return { yesNoOptions };
  },
};
</script>

<template>
  <div>
    <div class="row mb-20">
      <div class="col span-6">
        <LabeledInput v-model="value.spec.storageos.volumeName" :mode="mode" :label="t('persistentVolume.storageos.volumeName.label')" :placeholder="t('persistentVolume.storageos.volumeName.placeholder')" />
      </div>
      <div class="col span-6">
        <LabeledInput v-model="value.spec.storageos.volumeNamespace" :mode="mode" :label="t('persistentVolume.storageos.volumeNamespace.label')" :placeholder="t('persistentVolume.storageos.volumeNamespace.placeholder')" />
      </div>
    </div>
    <div class="row mb-20">
      <div class="col span-6">
        <LabeledInput v-model="value.spec.storageos.secretRef.name" :mode="mode" :label="t('persistentVolume.shared.secretName.label')" :placeholder="t('persistentVolume.shared.secretName.placeholder')" />
      </div>
      <div class="col span-6">
        <LabeledInput v-model="value.spec.storageos.secretRef.namespace" :mode="mode" :label="t('persistentVolume.shared.secretNamespace.label')" :placeholder="t('persistentVolume.shared.secretNamespace.placeholder')" />
      </div>
    </div>

    <div class="row mb-20">
      <div class="col span-6">
        <LabeledInput v-model="value.spec.storageos.fsType" :mode="mode" :label="t('persistentVolume.shared.filesystemType.label')" :placeholder="t('persistentVolume.shared.filesystemType.placeholder')" />
      </div>
      <div class="col span-6">
        <RadioGroup
          v-model="value.spec.storageos.readOnly"
          name="readOnly"
          :mode="mode"
          :label="t('persistentVolume.shared.readOnly.label')"
          :options="yesNoOptions"
          :row="true"
        />
      </div>
    </div>
  </div>
</template>
